import { Badge, severityVariant } from '@/shared/components/Badge'

export type SecurityBadgeProps = {
  status: string | null | undefined
  critical: number
  high: number
  low: number
}

export function SecurityBadge({ status, critical, high, low }: SecurityBadgeProps) {
  if (!status) return <span style={{ color: 'var(--text3)', fontSize: '0.75rem' }}>-</span>
  if (status === 'pending' || status === 'processing') {
    return (
      <Badge variant="neutral">
        <span className="spinner" style={{ width: 10, height: 10, marginRight: 4 }} />
        scanning
      </Badge>
    )
  }
  if (status === 'failed') return <Badge variant="neutral">scan failed</Badge>
  return (
    <span style={{ display: 'flex', gap: 4, flexWrap: 'wrap', alignItems: 'center' }}>
      {critical > 0 && <Badge variant={severityVariant('critical')}>⚠ {critical} critical</Badge>}
      {high > 0 && <Badge variant={severityVariant('high')}>{high} high</Badge>}
      {low > 0 && <Badge variant={severityVariant('low')}>{low} low</Badge>}
      {critical === 0 && high === 0 && low === 0 && <Badge variant="green">✓ clean</Badge>}
    </span>
  )
}
